// ======= Sousse =======
// const EnvPosition = JSON.parse(process.env.REACT_APP_INIT_MAP_POSITION) ?? [
//   35.83422413, 10.59211575,
// ];
const EnvPosition = [35.83422413, 10.59211575];

export const getInitLocation = () => {
  try {
    const location = JSON.parse(localStorage.getItem("userData"))?.location;

    if (location) {
      const locationArray = location
        .replace(/[()]/g, "")
        .split(",")
        .map(Number)
        .reverse();

      return locationArray;
    }
  } catch {
    return EnvPosition;
  }

  return EnvPosition;
};

export const getLocation = (pos) => {
  return "";
};

export const parsePosition = (value) => {
  if (!value) return [0, 0];
  const match = value.match(/\(([^,]+),([^,]+)\)/);
  return match ? [parseFloat(match[1]), parseFloat(match[2])] : [0, 0];
};
